import { useMemo } from "react";

import { activityNeedsUserAttention } from "./activityCardActions";
import { mockActivitiesFeed } from "./activitiesMock";
import { isActivitiesMockMode } from "./activitiesMockMode";

/** Sidebar badge: any activity feed item that still needs a user response. */
export function useActivitiesNeedsAttention(): boolean {
  return useMemo(() => {
    if (!isActivitiesMockMode({})) return false;
    const { events } = mockActivitiesFeed();
    return events.some(activityNeedsUserAttention);
  }, []);
}
